import React, { useEffect, useState } from 'react'
import './trade-offer-notification-modal.styles.scss'
import Modal from '@/components/modal/modal.component'
import { useLocation, useNavigate } from 'react-router-dom'
import { UseCloudGameTransactions } from '@/utils/firebase.utils'
import { useSelector } from 'react-redux'

const TradeOfferNotificationModal = ({ gameData, playerData }) => {
  const screenSize = useSelector(state => state.contentData.screenSize)
  const [show, setShow] = useState(false)
  const [pending, setPending] = useState([])
  const navigate = useNavigate()
  const location = useLocation()

  useEffect(() => {
    if (!playerData?.newStuff?.length) {
      setShow(false)
      setPending([])
      return
    }
    const offers = playerData.newStuff.filter(n => n.type === 'tradeOffer')
    if (offers.length > 0) {
      setPending(offers)
      setShow(true)
    } else {
      setShow(false)
      setPending([])
    }
  }, [playerData])

  async function dismiss(ids) {
    setShow(false)
    if (!location.pathname.includes('/preview/player/')) {
      await UseCloudGameTransactions('markRewardAsViewed', {
        gameId: gameData.gameId,
        playerId: playerData.playerId,
        rewardIdArr: ids,
      })
    }
  }

  async function handleViewTrade() {
    const first = pending[0]
    const ids = pending.map(n => n.id)
    await dismiss(ids)
    const base = location.pathname.includes('/preview/player/')
      ? `/preview/player/${gameData.path}`
      : `/play/${gameData.path}`
    navigate(`${base}/tradeportal/post/${first.tradeId}`)
  }

  async function handleLater() {
    await dismiss(pending.map(n => n.id))
  }

  if (!show || pending.length === 0) return null

  const count = pending.length
  const offererName = count === 1 ? pending[0].offererName : null

  return (
    <Modal
      show={show}
      cancel={handleLater}
      cls={screenSize === 'mobile' ? 'full' : 'narrow'}
    >
      <div className={`trade-offer-notification-modal ${screenSize}`}>
        <div className='ton-icon'>
          <ImageContainer src='/images/icons/tradeportal.png' alt='trade icon' className='ton-icon-image' />
        </div>
        <h2>
          {count === 1
            ? <><strong>{offererName}</strong> made an offer on your trade!</>
            : <>You have <strong>{count}</strong> new offers on your trades!</>
          }
        </h2>
        <p className='ton-sub'>Head to your trade to review and respond.</p>
        <hr />
        <div className='ton-buttons'>
          <button className='g-button' onClick={handleLater}>
            Later
          </button>
          <button className='g-button primary' onClick={handleViewTrade}>
            View Trade
          </button>
        </div>
      </div>
    </Modal>
  )
}

export default TradeOfferNotificationModal
